
import {callApi, callApiRaw, postApiForm} from "./call";
import {getToken} from "@ventumsoftware/react-toolkit";


export abstract class AbstractRepository {
    private baseUrl: string
    private selectedClient: string|undefined

    constructor(baseUrl: string, selectedClient?: string) {
        this.baseUrl = baseUrl;
        this.selectedClient = selectedClient;
    }

    protected request<T>(method: "GET"|"POST"|"PUT"|"PATCH"|"DELETE", endpoint: string, body?: unknown, requestOptions?: {fileFormName?: string}) {
        return callApi<T>(this.baseUrl, getToken() ?? undefined, this.selectedClient, endpoint, method, body, requestOptions)
    }
    protected rawRequest(method: "GET"|"POST"|"PUT"|"PATCH"|"DELETE", endpoint: string, body?: unknown, requestOptions?: {fileFormName?: string}) {
        return callApiRaw(this.baseUrl, getToken() ?? undefined, this.selectedClient, endpoint, method, body, requestOptions)
    }
  protected formPostRequest<T>(endpoint: string, formData: FormData) {
    return postApiForm<T>(this.baseUrl, getToken() ?? undefined, this.selectedClient, endpoint, formData)
  }

    protected unauthorizedRequest<T>(method: "GET"|"POST"|"PUT"|"PATCH"|"DELETE", endpoint: string, body?: unknown, requestOptions?: {fileFormName?: string}) {
        return callApi<T>(this.baseUrl, undefined, undefined, endpoint, method, body, requestOptions)
    }

    protected unpackDataCollectionResponse<T>(response: { data: T[]|{[k: number]: T} }): T[] {
        const list = response.data
        return Array.isArray(list) ? list : Object.values(list)
    }
}

